// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__biqKh","inner":"Footer_inner__Jm9ze"};